import { Injectable, inject } from '@angular/core';
import { BaseModel } from '../models/basemodel';
import { AbstractDataService } from './abstractdata.service';
import { DataTableModuleConfiguration } from './datatable-module.config';

@Injectable({ providedIn: 'root' })
export class ConfigurationDataService<T extends BaseModel> extends AbstractDataService<T> {
  constructor() {
    const configuration = inject(DataTableModuleConfiguration);
    if (!configuration.apiUrls.configurations) {
      throw new Error('Configuration API URL is not configured');
    }
    super(configuration.apiUrls.configurations);
  }
}
